/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_FormsInputs */

const en_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form inputs with associated labels and error messages`)
};

const de_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulareingaben mit zugeordneten Beschriftungen und Fehlermeldungen`)
};

const fr_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champs de formulaire avec etiquettes et messages d'erreur associes`)
};

const es_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campos de formulario con etiquetas asociadas y mensajes de error`)
};

const it_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campi modulo con etichette associate e messaggi di errore`)
};

const nl_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formuliervelden met bijbehorende labels en foutmeldingen`)
};

const pl_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pola formularzy z powiazanymi etykietami i komunikatami o bledach`)
};

const fi_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lomakekentat liittyvine otsikoineen ja virheilmoituksineen`)
};

const da_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formularfelter med tilknyttede etiketter og fejlmeddelelser`)
};

const sv_a11y_statement_accessible_forms = /** @type {(inputs: A11y_Statement_Accessible_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formularfalt med tillhorande etiketter och felmeddelanden`)
};

/**
* | output |
* | --- |
* | "Form inputs with associated labels and error messages" |
*
* @param {A11y_Statement_Accessible_FormsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_forms = /** @type {((inputs?: A11y_Statement_Accessible_FormsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_FormsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_forms(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_forms(inputs)
	if (locale === "es") return es_a11y_statement_accessible_forms(inputs)
	if (locale === "it") return it_a11y_statement_accessible_forms(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_forms(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_forms(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_forms(inputs)
	if (locale === "da") return da_a11y_statement_accessible_forms(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_forms(inputs)
	return en_a11y_statement_accessible_forms(inputs)
});